
import ProductListItem from '@/components/ProductListItem.vue'
import Loading from '@/components/Loading.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import { buildOgLocaleMeta, buildOgImageMeta } from '@/utils/seo'
import {
  entitySlugForLocale,
  buildHreflangLinks,
  computeAlternateUrls,
} from '@/utils/hreflang'

export default {
  name: 'DealShow',
  components: { Breadcrumb, Loading, ProductListItem },
  data() {
    return {
      deal: null,
      breadcrumb_list: [],
      languageMap: {},
    }
  },
  async fetch() {
    const languageMapPromise = this.$getLanguageMap().then(map => {
      this.languageMap = map
    })

    await this.$goodDealService
      .fetchDealShow(this.$route.params.slug)
      .then(({ data }) => {
        this.deal = data
        this.breadcrumb_list = [
          {
            text: this.$t('pages.bonnesAffaires.slug.home'),
            to: { name: 'index' },
          },
          {
            text: this.$t('pages.bonnesAffaires.slug.deals'),
            to: {
              name: 'bonnes-affaires',
            },
          },
          {
            text: this.deal.title,
            to: {
              name: 'bonnes-affaires-slug',
              params: { slug: this.deal.slug },
            },
          },
        ]
      })
      .catch(() => {
        this.$404Error()
      })

    await languageMapPromise

    if (this.deal) {
      computeAlternateUrls({
        locales: this.$i18n.locales,
        localePath: this.localePath,
        routeName: 'bonnes-affaires-slug',
        buildParams: code => this.dealParamsForLocale(code),
        store: this.$store,
      })
    }
  },
  head() {
    if (this.deal) {
      return {
        title: this.deal.meta_title,
        link: [
          {
            hid: 'i18n-can',
            rel: 'canonical',
            href:
              this.$config.url +
              this.localePath({
                name: 'bonnes-affaires-slug',
                params: { slug: this.deal.slug },
              }),
          },
          ...buildHreflangLinks({
            locales: this.$i18n.locales,
            configUrl: this.$config.url,
            localePath: this.localePath,
            routeName: 'bonnes-affaires-slug',
            buildParams: code => this.dealParamsForLocale(code),
            store: this.$store,
          }),
        ],
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: this.deal.meta_description,
          },
          { hid: 'og:type', property: 'og:type', content: 'website' },
          {
            hid: 'og:url',
            property: 'og:url',
            content:
              this.$config.url +
              this.localePath({
                name: 'bonnes-affaires-slug',
                params: { slug: this.deal.slug },
              }),
          },
          {
            hid: 'og:title',
            property: 'og:title',
            content: this.deal.meta_title,
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: this.deal.meta_description,
          },
          {
            hid: 'og:site_name',
            property: 'og:site_name',
            content: 'AGM Vision',
          },
          ...buildOgLocaleMeta(this.$i18n.locale),
          ...buildOgImageMeta({
            url: this.ogImage.url,
            width: this.ogImage.width,
            height: this.ogImage.height,
            alt: this.ogImage.alt,
          }),
          {
            hid: 'twitter:title',
            name: 'twitter:title',
            content: this.deal.meta_title,
          },
          {
            hid: 'twitter:description',
            name: 'twitter:description',
            content: this.deal.meta_description,
          },
        ],
      }
    }
  },
  computed: {
    ogImage() {
      const img = this.deal?.image
      const alt = this.deal?.meta_title
      if (img && img.url) {
        return {
          url: img.url.startsWith('http')
            ? img.url
            : `${this.$config.url}${img.url}`,
          width: img.width || null,
          height: img.height || null,
          alt,
        }
      }
      return {
        url: `${this.$config.url}/logo_og.png`,
        width: 512,
        height: 512,
        alt,
      }
    },
    urlToAdminPage() {
      return `${this.$config.adminUrl}/bonnes-affaires/${this.deal.id}`
    },
  },
  methods: {
    dealParamsForLocale(code) {
      if (!this.deal?.slug) {
        return null
      }

      const slug = entitySlugForLocale(this, this.deal, code)

      return slug ? { slug } : null
    },
  },
}
